export default __webpack_public_path__ + "static/media/alta_masiva.ca164840.xlsx";